module.exports = __webpack_public_path__ + "static/media/logo.fdd17039.png";